import React, { useState } from 'react';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";

import Close from '../../assets/kinologyIcons/svg/close.svg';
import {ReactComponent as Warning} from '../../assets/kinologyIcons/svg/WorningRed.svg';

import { panelCreatedProps } from './Dashboard';
import moment from 'moment';
import { useSelector } from 'react-redux';

interface PanelProps {
	close:()=> void;
	action: ()=> void;
	isNewPanel: boolean
};

const ConfirmPanelDeletion: React.FC<PanelProps> = ({
	action,
	close,
	isNewPanel
})=> {

	const open = useSelector(
		(state: any) => state.dashboard.modal_delete_panel
	);
	const load_delete = useSelector(
		(state: any) => state.dashboard.load_delete_panel_dash_dynalabs
	);
		
	return (
		<AlertDialog 
			open={open} 
			onOpenChange={()=>close()}
		>
			<AlertDialogContent
				className={`w-[350px] bg-[#F1F2F3] flex flex-col items-center justify-center p-10 rounded-xl`}
			>
				<AlertDialogTrigger className={`absolute right-5 top-5`} onClick={()=>	{}}>
					<img src={Close} alt="" className={`w-4 h-4 cursor-pointer`} />
				</AlertDialogTrigger>

				<AlertDialogTrigger className={`self-center `} onClick={()=>	{}}>
					{/* <img src={Warning} alt="" className={`w-8 h-8 `} color={'#D12600'} /> */}
					<Warning className={` w-12 h-12 self-center`} color={'#D12600'} />
				</AlertDialogTrigger>

				<AlertDialogDescription className={`text-center  text-[#000E4B] font-bold text-xl font-[Noto Sans]`}
				>
					{
						isNewPanel
						?	'Deseja sair sem salvar o painel?'
						: 'Deseja sair sem salvar o painel?'
					}
				
				</AlertDialogDescription>

				<AlertDialogDescription className={`text-center mt-5 text-[#63677A] font-normal text-xs font-[Noto Sans] `}
				>
					{
						isNewPanel
						? 'Ao cancelar, o painel não será salvo e precisará criar um novo. Não será possível recuperá-lo'
						: 'Ao cancelar, as alterações não serão salvas.'
					}
					
				</AlertDialogDescription>
				<AlertDialogDescription className={`flex w-full justify-between  `}>
					<Button
						onClick={() =>{
							action()
						}}
						className={`w-[48%] p-4 items-center border-2 border-[#D12600] rounded-lg  text-[#000E4B] font-semibold font-[Kanit-Regular]`}
					>
						{
							load_delete
							? <div className="flex items-center justify-center h-4">
									<div className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-solid border-[#000E4B] border-t-transparent"></div>
								</div>
							: "Sair sem salvar" 
						}
						
					</Button>
					<Button
						onClick={() =>{
							close()
						}}
						className={`w-[48%] p-4 items-center border-2 border-[#000E4B] rounded-lg text-[#000E4B] font-semibold font-[Kanit-Regular]`}
					>
						Continuar edição
					</Button>
				</AlertDialogDescription>
			</AlertDialogContent>
		</AlertDialog>
	);
};
export default ConfirmPanelDeletion;